import { ChatAPI } from './api'
import { ChatHooks } from './hooks'
import { ApisauceInstance } from 'apisauce'
import * as chatStore from './stores'
import { ChatServices } from './services'
import { Constants } from './constants'
import { ChatPackageConstructorOptions } from './types'
import { ChatQueries } from './queries'

export class ChatPackage {
  public API: ChatAPI
  public Hooks: ChatHooks
  public Services: ChatServices
  public Queries: ChatQueries
  public Store: typeof chatStore
  public Constants = Constants
  protected api: ApisauceInstance
  protected queryClient: ChatPackageConstructorOptions['queryClient']
  public getChatClient: ChatPackageConstructorOptions['getChatClient']

  constructor(props: ChatPackageConstructorOptions) {
    this.api = props.api
    this.queryClient = props.queryClient
    this.getChatClient = props.getChatClient

    this.API = new ChatAPI(props)
    this.Store = chatStore
  
    this.Queries = new ChatQueries({ ...props, chatApi: this.API, queryClient: this.queryClient })
    this.Hooks = new ChatHooks({ ...props, chatApi: this.API, queries: this.Queries })
    this.Services = new ChatServices({ ...props, chatApi: this.API, queries: this.Queries })
  }

  log(msg: string) {
    console.log(`💬 Chat Package: ${msg}`)
  }

  async disconnect() {
    try {
      const client = await this.getChatClient({ connectUser: false })
      chatStore.clear()
      const user = client.user
      await client.disconnectUser()
      this.log(`${user?.name} was disconnected!`)
    }catch (e) {
      this.log(`Error during disconnect: ${e}`)
    }
  }
}

export * from './config'
export * from './types'
export * from './utils'
export * from './stores'
export * from './assets'
export * from './hooks'